import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { IconButton, Stack } from '@mui/material';
import useCurrentSection from './Hooks/useCurrentSection';
import { useParams } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { txt } from '../../services/translation';

export default function Header({onNavToggle, nav}){

    const section = useCurrentSection();
    const {tab} = useParams();
    
    const title = () => {

        const tabs = {
            course: txt('courseTab'),
            notes: txt('notesTab'),
            docs: txt('docsTab'),
            epp: txt('eppTab'),
            fifpl: txt('fifplTab'),
            forum: txt('forumTab'),
            search: txt('searchTab'),
        };

        return section ? section.title : tabs[tab];
    }

    return <header className='study-header'>

        <Stack direction='row' alignItems='center' spacing={1}>

            <div className='study-mobile'>
                <IconButton onClick={onNavToggle}>
                    <MenuIcon />
                </IconButton>
            </div>

            <b className='study-title'>{title()}</b>

        </Stack>
        

        <div className='study-desktop'>
            <IconButton onClick={onNavToggle} size='small'>
                {nav ? <FullscreenIcon /> : <FullscreenExitIcon />}
            </IconButton>
        </div>

    </header>
}